module.exports = __webpack_public_path__ + "dz.44d357120268c248da36.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/dz.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/dz.svg
// module chunks = styles